// src/app/store/auth/auth.selectors.ts
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { AuthState } from './auth.reducer';

export const selectAuth = createFeatureSelector<AppState, AuthState>('auth');
export const selectAccessToken = createSelector(
  selectAuth,
  (s) => s.accessToken
);

export const selectIsAuthenticated = createSelector(selectAuth, (a) => {
  const t = a?.accessToken;
  if (!t?.accessToken || !t?.refreshToken) return false;
  if (!t.expiresAt) return true; // fallback permisivo
  return Date.now() < t.expiresAt;
});
